import React from 'react';
import './file.css';

const Resume = () => {
  return (
    <div className="file-page">
      <embed
        src="files/resume_2026.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
        title="Kyra Thomas Resume"
      />
    </div>
  );
};

export default Resume;
